import Colcade from 'colcade';

export default class ColcadeLayout {
	private static readonly domSelectors: Record<'layout' | 'col' | 'item', string> = {
		layout: '.l-colcade',
		col: '.l-colcade__col',
		item: '.l-colcade__item'
	};

	private static readonly stateClasses: Record<'isColcadeLayout', string> = {
		isColcadeLayout: 'is-colcade-layout'
	};

	private readonly element: Element;

	private colcade?: Colcade;

	public constructor(element: Element) {
		this.element = element;

		this.init();
		window.addEventListener('resize', (): void => this.reset());
	}

	public destroy(): void {
		if (!this.colcade) {
			return;
		}

		this.element.classList.remove(ColcadeLayout.stateClasses.isColcadeLayout);
		this.colcade.destroy();
		delete this.colcade;
	}

	public reset(): void {
		this.destroy();
		this.init();
	}

	private init(): void {
		const firstColumn: Element | null = this.element.querySelector(ColcadeLayout.domSelectors.col);

		// Don't init colcade if first column (=all columns) are hidden
		if (!firstColumn || window.getComputedStyle(firstColumn).display === 'none') {
			return;
		}

		if (!this.colcade) {
			this.element.classList.add(ColcadeLayout.stateClasses.isColcadeLayout);

			this.colcade = new Colcade(this.element.querySelector(ColcadeLayout.domSelectors.layout) || this.element, {
				columns: ColcadeLayout.domSelectors.col,
				items: ColcadeLayout.domSelectors.item
			});
		}
	}
}
